import { ResidenceOrigin } from 'shell/view-models/personal-data';

interface PraticePersonReidenceOriginUpdateTransformerParams {
  params: {
    codiceEnte?: string;
    tipoRegistro?: string;
    idAnnoPratica?: string;
    progressivoPratica?: string;
  };
  sipoSerialNumber?: number;
  residenceOrigin?: ResidenceOrigin;
  italianMunicipality: {
    comune: {
      nomeComune?: string;
      codiceIstat?: string;
      siglaProvinciaIstat?: string;
    };
  };
  foreignMunicipality: {
    localita: {
      descrizioneStato?: string;
      codiceStato?: string;
      provinciaContea?: string;
      descrizioneLocalita?: string;
    };
  };
  idAnpr?: string;
}

export const praticePersonResidenceOriginUpdateTransformer = (
  data: PraticePersonReidenceOriginUpdateTransformerParams
) =>
  ({
    matricolaSipo: data?.sipoSerialNumber?.toString() || '',
    idSchedaSoggettoAnpr: data?.idAnpr || undefined,
    praticaKey: {
      codiceEnte: data?.params.codiceEnte || undefined,
      tipoRegistro: data?.params.tipoRegistro || undefined,
      idAnnoPratica: data?.params.idAnnoPratica
        ? Number.parseInt(data?.params.idAnnoPratica, 10)
        : undefined,
      progressivoPratica: data?.params.progressivoPratica
        ? Number.parseInt(data?.params.progressivoPratica, 10)
        : undefined,
    },
    irreperibile: data?.residenceOrigin?.irreperibile || false,
    minorePreadozione: data?.residenceOrigin?.neverRegistered || false,
    comunePrecedente:
      data?.residenceOrigin?.previousOriginCode ||
      data?.residenceOrigin?.previousOriginSipoCode ||
      data?.residenceOrigin?.previousOrigin ||
      data?.residenceOrigin?.previousOriginProvince
        ? {
            codice: data?.residenceOrigin?.previousOriginCode || undefined,
            codiceSipo: data?.residenceOrigin?.previousOriginSipoCode || undefined,
            descrizione: data?.residenceOrigin?.previousOrigin || undefined,
            provincia: data?.residenceOrigin?.previousOriginProvince || undefined,
          }
        : undefined,

    ...(!data?.residenceOrigin?.isForeign ? data?.italianMunicipality : data?.foreignMunicipality),
  } as const);
